import { Box, Typography, Button, Divider } from '@mui/material';

/**
 * Restricted currency notification body for MDForm CustomModal.
 * Matches legacy rstdCcyModal fragment (title, message, OK).
 */
const RstdCcyModalContent = ({
        message = '',
        okLabel = 'OK',
        onOk,
}) => {
        const handleOk = () => {
                if (onOk) {
                        onOk();
                }
        };

        return (
                <Box id="rstdCcyMdlFrgmtId" sx={{ display: 'flex', flexDirection: 'column' }}>
                        <Box className="modal-body" sx={{ py: 2 }}>
                                <Typography
                                        id="rstdCcyCnfrmMsg"
                                        component="h6"
                                        variant="subtitle1"
                                        sx={{ color: '#828080', fontWeight: 400, m: 0 }}
                                >
                                        {message}
                                </Typography>
                        </Box>
                        <Divider />
                        <Box className="modal-footer" sx={{ display: 'flex', justifyContent: 'center', py: 2 }}>
                                <Button
                                        type="button"
                                        variant="contained"
                                        color="success"
                                        size="small"
                                        onClick={handleOk}
                                >
                                        {okLabel}
                                </Button>
                        </Box>
                </Box>
        );
};

export default RstdCcyModalContent;
